import type React from 'react';
import { type IWidgetComponentOptionProps } from '../../../../IWidgetType.ts';
import { type IComponentOptions } from '../../../../WidgetOptionLogic.ts';
import { type IMultiSelectWidget } from '../../multi-select/IMultiSelectWidget.ts';
import { type ISingleSelectWidget } from '../../single-select/ISingleSelectWidget.ts';
import { type IWidgetParsedProps } from '../util/getWidgetProps.ts';
import { optionsOrPreviewOptions } from './optionsOrPreviewOptions.tsx';
import { OptionsGroup } from './style/OptionsGroup.tsx';

export interface ISelectListOptionProps {
  widget: IMultiSelectWidget | ISingleSelectWidget;
  options: IComponentOptions;
  OptionComponent: React.ComponentType<IWidgetComponentOptionProps<any>>;

  widgetOptions: IWidgetParsedProps;

  readonly?: boolean;
}

/**
 * Gestisce in maniera centralizzata la visualizzazione delle option di un widget di tipo Select (singola/multipla)
 * in formato lista di checkbox o radio.
 */
export function SelectListOption(props: ISelectListOptionProps) {
  const { options, widgetOptions, OptionComponent, widget } = props;

  if (options.type === 'flat') {
    return (
      <>
        {optionsOrPreviewOptions(options.values, widgetOptions.preview).map(
          option => (
            // Use optionComponent as react component
            <OptionComponent
              readonly={props.readonly}
              option={option}
              key={option.value}
              widget={widget}
              name={option.value}
              groupName={widgetOptions.name}
              preview={widgetOptions.preview}
            />
          ),
        )}
      </>
    );
  }

  return (
    <>
      {options.options.map((group, index) => (
        <OptionsGroup
          key={index}
          label={group.label}
          vertical={widget.layout?.direction === 'vertical'}
          labelLikeText={widget.layout?.separator === 'text'}
          widgetHideLabel={widget.layout?.hideLabel}
        >
          {group.options?.map((option, i) => (
            <OptionComponent
              readonly={props.readonly}
              option={option}
              key={option.value}
              widget={widget}
              name={option.value}
              groupName={widgetOptions.name}
            />
          ))}
        </OptionsGroup>
      ))}
    </>
  );
}
